import type { FieldBorderOperation } from '../../types'

import { call } from 'redux-saga/effects'

import { validateModel } from 'fc-model-fieldborder'

export default function *validateOperationSaga (operation: FieldBorderOperation): Generator<*, *, *> {
  const errors = yield call(validateModel, operation.model)

  const nextOperation = {
    ...operation,
    submitting: false,
    errors,
  }

  return nextOperation
}
